
import React from "react";
import styled from "styled-components";
import { Td, TdGradient, Tr } from "../StatisticDesign";

const FloorRow = styled.tr`
    background: #0b8143;
`;

const FloorCell = styled.td`
    padding: 10px 14px;
    color: white;
    font-size: 13px;
    font-weight: 700;
    text-align: left;
    border-bottom: 1px solid #047139;
`;

const TypeRow = styled.tr`
    background: #e6f5eb;
`;

const TypeCell = styled.td`
    padding: 8px 14px 8px 24px;
    color: #166534;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #ccebd5;
`;

const WorkCell = styled(Td)`
    text-align: left;
    width: auto;
    min-width: 0;
    overflow-wrap: anywhere;
    padding-left: 24px;
    font-weight: 500;
`;

const StatisticTableRow = ({
                               Floors = {},
                               Dates = [],
                               house,
                               frontId
                            }) => {
    const totalColumns = 3 + Dates.length;


    function clickOnTr(event) {
        console.log(event.currentTarget.dataset.frontid);

    }

    return (
        <>
            {Object.entries(Floors).map(([floor, floorData]) => (
                <React.Fragment key={floor}>
                    <FloorRow>
                        <FloorCell colSpan={totalColumns}>
                            {floor}
                        </FloorCell>
                    </FloorRow>

                    {Object.entries(
                        floorData.ProgressWorks ?? {}
                    ).map(([workType, works]) => (
                        <React.Fragment key={workType}>
                            <TypeRow>
                                <TypeCell colSpan={totalColumns}>
                                    {workType}
                                </TypeCell>
                            </TypeRow>

                            {Object.entries(works).map(
                                ([work, values]) => (
                                    <Tr key={work}>
                                        <Td />
                                        <Td />
                                        <WorkCell>{work}</WorkCell>

                                        {Dates.map((date) => {
                                            const value = values.find(
                                                (item) =>
                                                    item.Data === date &&
                                                    Number(item.Percent) !== 0
                                            );

                                            return value ? (
                                                <TdGradient
                                                    key={date}
                                                    $value={Number(value.Percent)}
                                                    data-frontid={value.frontId}
                                                    onClick={clickOnTr}
                                                >
                                                    {value.Percent}%
                                                </TdGradient>
                                            ) : (
                                                <Td key={date}>—</Td>
                                            );
                                        })}
                                    </Tr>
                                )
                            )}
                        </React.Fragment>
                    ))}
                </React.Fragment>
            ))}
        </>
    );
};

export default StatisticTableRow;
